var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoMoveToFolder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_MoveToFolder",
    transform: "translate(19458.002 11968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_20",
    "data-name": "Subtraction 20",
    d: "M16.5,15H1.5A1.5,1.5,0,0,1,0,13.5V1.5A1.5,1.5,0,0,1,1.5,0H7.125A.377.377,0,0,1,7.39.11L8.78,1.5H16.5A1.5,1.5,0,0,1,18,3V13.5A1.5,1.5,0,0,1,16.5,15ZM2.706,7.355A.684.684,0,0,0,2,8.013v2.974a.684.684,0,0,0,.707.657H7.523v.7a.653.653,0,0,0,.437.606A.767.767,0,0,0,8.23,13a.719.719,0,0,0,.5-.192l3.063-2.845A.63.63,0,0,0,12,9.5a.639.639,0,0,0-.208-.466L8.73,6.192a.763.763,0,0,0-.77-.144.656.656,0,0,0-.437.607v.7Z",
    transform: "translate(-19458.002 -11968)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoMoveToFolder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_move_to_folder.56f02897b011d07cd87bb7444771aa02.svg";